import { render, staticRenderFns } from "./LandPurchaseDataPopup.vue?vue&type=template&id=da635dd8&scoped=true"
import script from "./LandPurchaseDataPopup.vue?vue&type=script&lang=js"
export * from "./LandPurchaseDataPopup.vue?vue&type=script&lang=js"
import style0 from "./LandPurchaseDataPopup.vue?vue&type=style&index=0&id=da635dd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da635dd8",
  null
  
)

export default component.exports